import React, { useContext } from 'react';
import {
  AccountsOverview,
  DataSources,
  OtherData,
  OutcomeReasons,
  RecentTransactions,
  Tags,
  WatchlistMatches,
} from '../cards';
import { Col, Row } from '../common';
import { useEventTypeEvaluationsContext } from '../context';
import { hasDataSourcesData, hasFraudSignalServiceConfigured } from '../../utils/cardDataChecks';
import { shouldRenderCard } from '../../utils/shouldRenderCard';
import { FraudSignalCard } from '../../FraudSignalCard';
import { UserContext } from '~/dashboard/context';
import { InvestigationTrxBaTab } from '~/investigations/components/InvestigationTrxBaTab/InvestigationTrxBaTab';

export const TransactionCards = () => {
  const { evaluation, isInvestigationPage } = useEventTypeEvaluationsContext();
  const { featureFlags } = useContext(UserContext);
  const hideEmptyCardsEnabled = Boolean(featureFlags?.removeEmptyCards);
  const showTrxBaCards = Boolean(featureFlags?.transactionPaColumns) && isInvestigationPage;

  return (
    <>
      <Row>
        <Col>
          <AccountsOverview />
        </Col>
        <Col>
          <OutcomeReasons />
          <Tags />
          <FraudSignalCard
            evaluationToken={evaluation.evaluation_token}
            hasFraudSignalService={hasFraudSignalServiceConfigured(evaluation)}
          />
          {shouldRenderCard(hasDataSourcesData(evaluation), hideEmptyCardsEnabled)
            && <DataSources />}
          <OtherData />
        </Col>
      </Row>
      {showTrxBaCards ? <InvestigationTrxBaTab bordered /> : <RecentTransactions />}
      <WatchlistMatches />
    </>
  );
};
